import { motion } from "framer-motion";
import Section from './hoc/Section';

const textVariant = {
  hidden: { opacity: 0, x: 70 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: 1.2, ease: "easeOut" },
  },
};

const Home = () => {
  return (
    <section className="relative w-full overflow-hiden min-h-[600px] sm:min-h-[700px] md:min-h-[800px] lg:min-h-[900px] xl:min-h-[1000px] my-2">

      {/* Responsive background image with dark overlay */}
      <div className="absolute inset-0 z-0 pointer-events-none h-full w-full">
        <img
          src="https://cdn.prod.website-files.com/67bf1d64e913376883f9957d/67c60b982b898029a7d34119_8155fccd08d673a922a6b7fd8448687c_Group%202147224606.webp"
          alt="bg-img"
          className="w-full h-full object-contain object-right"
        />
        <div className="absolute inset-0 opacity-60 bg-[#050518]"></div>
      </div>

      {/* Content */}
     <div className="relative z-10 px-4 sm:px-6 md:px-10 pt-32 sm:pt-36 pb-12 max-w-7xl mx-auto">
        <motion.div
          variants={textVariant}
          initial="hidden"
          whileInView="show"
          viewport={{ amount: 0.3 }}
          className="max-w-3xl"
        >
          <h4 className="font-semibold text-white text-3xl sm:text-4xl lg:text-[70px] pt-20 leading-tight">
            Extrnl.io
            <span className="block text-sm sm:text-lg font-medium text-gray-300 mt-4">
             International team. Global impact.
            </span>
            <span className="block text-indigo-500 text-lg sm:text-xl lg:text-5xl mt-2">
              Engineering <span className="pl-1">the </span>Future
            </span>
          </h4>
          <p className="text-slate-300 text-xs sm:text-sm lg:text-lg mt-4 leading-[26px]">
            "Passionate developers delivering cutting-edge blockchain solutions that blend innovation, scalability, and business success."
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Section(Home, "home");
